import React, { useContext } from 'react';
import { makeStyles, MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import clsx from 'clsx';

import { MenuListSizeContext } from '#web-components/components/MenuList/MenuList';
import Typography from '#web-components/components/Typography';
import styles from './MenuItem.styles';

type MenuItemProps = {
  children: React.ReactNode,
  className?: string,
  disabled?: boolean,
  selected?: boolean,
  onClick?: MuiMenuItemProps['onClick'],
  size?: 'small' | 'medium';
  component?: React.ElementType;
  'data-xpath'?: string,
  textClassName?: string,
};

const useStyles = makeStyles(styles, { name: 'MenuItem' });

export default function MenuItem({
  children, className, onClick, 'data-xpath': dataXpath, disabled, selected, size, component = 'li', textClassName,
}: MenuItemProps) {
  const itemSize = useContext(MenuListSizeContext);
  const isSmallSize = (itemSize === 'small' || size === 'small');
  const typographyVariant = isSmallSize ? 'textSmallCompact' : 'textRegular';
  const classes = useStyles();
  return (
    <MuiMenuItem
      component={component}
      className={clsx(
        classes.enabled,
        className,
        isSmallSize && classes.small,
        !onClick && classes.plain,
      )}
      onClick={onClick}
      data-xpath={dataXpath}
      disabled={disabled}
    >
      <Typography variant={typographyVariant} className={clsx(classes.value, textClassName)}>
        {children}
      </Typography>
      {selected && <DoneIcon className={classes.icon} />}
    </MuiMenuItem>
  );
}
